import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '@bld/bld-libs/components';
import Tooltip from '@mui/material/Tooltip';

import { useFieldBulletinBoards } from '../../services/fieldBulletinBoard/FieldBulletinBoardsContext';

import _masterSlideLoader from '../../utilities/masterSlideLoader';
import { messageUtility } from '../../utilities/messageUtility';

export function FieldBulletinBoardsHeader() {
  const {
    getFieldInfo,
    getIsEditable,
    getIsDisabled,
    getFixedSearchParam,
    getIsMainJv
  } = useFieldBulletinBoards();

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between', margin: '16px' }}
    >
      <Box>
        <Typography sx={{ fontSize: '12px' }}>
          {messageUtility.getMessage('I-000-164-02')}
        </Typography>
        <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
          {getFieldInfo().name}
        </Typography>
      </Box>
      {/* MJVの元請けユーザにのみ表示 */}
      {getIsEditable() && getIsMainJv() && (
        <Tooltip
          title={messageUtility.getMessage('I-000-164-18')}
          disableFocusListener
          disableHoverListener={!getIsDisabled()}
          disableTouchListener={!getIsDisabled()}
          placement='bottom'
          arrow
        >
          <span>
            <Button
              variant='contained'
              color='primary'
              disabled={getIsDisabled()}
              onClick={() =>
                _masterSlideLoader.show('FieldBulletinBoardRegister', {
                  state: {
                    fieldBulletinBoardSearchParam: getFixedSearchParam(),
                  },
                })
              }
              sx={{ width: '160px', borderRadius: '8px' }}
            >
              {messageUtility.getMessage('I-000-164-03')}
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardsHeader.jsx